/* LIQUID_GOLD: smooth scrolling — Rally at Sherwood Village.
   Boots the vendored Lenis build (liquid_gold_lenis.js, https://lenis.dev) and
   exposes it as window.LiquidGold.scroll. Loaded from liquid_gold_head only when
   Theme settings → LGO — Smooth scroll is on and never inside the theme editor.
   Options arrive as data- attributes on this script tag. */

(function () {
  'use strict';

  window.LiquidGold = window.LiquidGold || {};
  var LG = window.LiquidGold;

  var script = document.currentScript;
  var attr = function (name) {
    return script ? script.getAttribute(name) : null;
  };
  var config = {
    duration: parseFloat(attr('data-lg-duration')) || 1.2,
    touch: attr('data-lg-touch') === 'true'
  };

  var lenis = null;

  /* Public surface. Every method is safe to call when Lenis never started
     (reduced motion, editor, missing build), so callers need no guards. */
  LG.scroll = {
    instance: function () {
      return lenis;
    },
    stop: function () {
      if (lenis) lenis.stop();
    },
    start: function () {
      if (lenis) lenis.start();
    },
    // Scroll to a selector, element or pixel offset, honouring the fixed header.
    to: function (target, options) {
      if (lenis) {
        lenis.scrollTo(target, Object.assign({ offset: -headerHeight() }, options || {}));
        return;
      }
      var el = typeof target === 'string' ? document.querySelector(target) : target;
      if (el && typeof el.scrollIntoView === 'function') el.scrollIntoView();
    }
  };

  // LIQUID_GOLD: the header is fixed, so anchors land just under it unless the
  // scroll offset accounts for its height (--lg-header-h is set by chrome.js).
  function headerHeight() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--lg-header-h');
    var n = parseFloat(raw);
    return isNaN(n) ? 0 : n;
  }

  function boot() {
    if (lenis || typeof window.Lenis !== 'function') return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (LG.reducedMotion && LG.reducedMotion()) return;

    lenis = new window.Lenis({
      duration: config.duration,
      syncTouch: config.touch,
      autoRaf: true,
      // Same-page links scroll smoothly and stop short of the fixed header.
      anchors: { offset: -headerHeight() },
      respectReducedMotion: true
    });

    // A drawer may already be open (lockScroll ran before this script executed).
    if (document.body.style.overflow === 'hidden') lenis.stop();
  }

  boot();
})();
